// extracted by mini-css-extract-plugin
export default {"pill-button":"PillButton_pill-button__9yrBa","pill-button__primary":"PillButton_pill-button__primary__lx9FW","pill-button__secondary":"PillButton_pill-button__secondary__OTm3u"};